/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.1
 */

import get from 'lodash/get';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { API_HOSTNAME, WIDGET_API, WIDGET_PAYMENTS } from '../../../../../modules/app/Api';
import { makeSelectLocalStorageSelectedAccount } from '../../../../../modules/storage/storageSelectors';
import { requestSaga } from '../../../../../sagas/requestSaga';
import { widgetPaymentHistoryFail, widgetPaymentHistorySuccess } from './widgetPaymentHistoryActions';

export function* loadPaymentsHistoryListSaga(): SagaIterator {
    const selectedAccount = (yield select(makeSelectLocalStorageSelectedAccount())).id;
    const URL = API_HOSTNAME + WIDGET_API + WIDGET_PAYMENTS + `/${selectedAccount}`;

    try {
        const response = yield call(requestSaga, URL, 'GET');
        const payments = get(response, 'payments', []);

        yield put(widgetPaymentHistorySuccess(payments));
    } catch (error: any) {
        yield put(widgetPaymentHistoryFail(error));
    }
}
